<template>
	<div class="terms-container">
		<p class="is-size-7 has-text-grey-light">
			<slot></slot>
			<a class="has-text-grey-light" target="_blank" href="https://www.touchpoint.io/terms">
				Terms of Service
			</a>
			and
			<a class="has-text-grey-light" target="_blank" href="https://www.touchpoint.io/privacy">
				Privacy Policy
			</a>
		</p>
	</div>
</template>

<script>
	export default {}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.terms-container {
		a {
			text-decoration: underline;
		}
	}
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseTermsBlurb.vue